import axios from 'axios';
import { Dispatch } from "redux";
import {
  PREORDER_EVENTS_LOADING,
  PREORDER_EVENTS_FAIL,
  PREORDER_EVENTS_LIST,
  PREORDER_EVENTS_REGISTER,
  PREORDER_EVENTS_REFRESH,
  PREORDER_EVENTS_SET_FILTER,
  PREORDER_EVENT_DETAILS_SUCCESS,
  PREORDER_EVENT_ARCHIVE_SUCCESS,
  PREORDER_EVENT_UPDATE_SUCCESS,
  PREORDER_ITEM_ADD_SUCCESS,
  PREORDER_ITEM_UPDATE_SUCCESS,
  PREORDER_ITEM_QUANTITY_UPDATE_SUCCESS,
  PREORDER_EVENT_ORDERS_LOADING,
  PREORDER_EVENT_ORDERS_SUCCESS,
  PREORDER_EVENT_ORDERS_FAIL,
  PREORDER_ORDER_UPDATE_LOADING,
  PREORDER_ORDER_UPDATE_SUCCESS,
  PREORDER_ORDER_UPDATE_FAIL,
  PREORDER_ITEMS_BULK_PUBLISH_LOADING,
  PREORDER_ITEMS_BULK_PUBLISH_SUCCESS,
  PREORDER_ITEMS_BULK_PUBLISH_FAIL,
  PreorderEventsDispatchTypes,
  PreorderEventFilters,
  CreatePreorderEventRequest,
  PreorderEventType,
  PreorderEventList,
  PreorderEventDetails,
  PreorderEventOrdersList,
  PREORDER_EVENT_SUGGESTED_LOADING,
  PREORDER_EVENT_SUGGESTED_SUCCESS,
  PREORDER_EVENT_SUGGESTED_FAIL,
  PREORDER_EVENT_SUGGESTED_CLEAR,
  PreorderCloseEventRequest
} from "./PreorderEventActionsTypes";

//  JWT decode token.
import jwtDecode from 'jwt-decode';
import { getProjectConfig } from "../../getProjectConfig";

const apiURL: string | undefined = process.env.REACT_APP_API_URL;

/**
 * Update the refresh preorder events view state.
 * @param {boolean} value
 */
export const refreshPreorderEventsView = (value: boolean) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  dispatch({
    type: PREORDER_EVENTS_REFRESH,
    payload: value
  })
};

/**
 * Update the preorder events view filters state.
 * @param {PreorderEventFilters} filters
 */
export const preorderEventsSetFilters = (filters: PreorderEventFilters) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  dispatch({
    type: PREORDER_EVENTS_SET_FILTER,
    payload: filters
  })
};

// /admin/getRecommendedClosedPreorder
export const getRecommendedClosedPreorder = ( preorderEventId: number ) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENT_SUGGESTED_LOADING,
        payload: 'GET_RECOMMENDED_CLOSED_PREORDER'
      });
      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };
      const res = await axios.get(`${apiURL}/admin/getRecommendedClosedPreorder`, {
        headers: headers,
        params: {
          preorderEventId: preorderEventId
        }
      });
      if (res.status === 200) {
        const responseData = res.data.data;
        console.log('recommended close preorder response:', responseData);
        dispatch({
          type: PREORDER_EVENT_SUGGESTED_SUCCESS,
          payload: responseData
        });
      } else {
        dispatch({
          type: PREORDER_EVENT_SUGGESTED_FAIL,
          payload: 'status.get-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENT_SUGGESTED_FAIL,
        payload: 'status.get-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENT_SUGGESTED_FAIL,
      payload: 'status.get-error'
    });
  }
};

/**
 * Close a preorder event with the specified stock distribution
 * @param {PreorderCloseEventRequest} closeRequest
 */
export const closePreorderEvent = (closeRequest: PreorderCloseEventRequest) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'CLOSE_PREORDER_EVENT'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const res = await axios.post(`${apiURL}/admin/closePreorderEvent`, closeRequest, {
        headers: headers
      });

      if (res.status === 200 || res.status === 201) {
        dispatch({
          type: PREORDER_EVENTS_REGISTER,
          payload: 'status.close-success'
        });
        // Clear the suggested distribution after successful close
        dispatch({
          type: PREORDER_EVENT_SUGGESTED_CLEAR
        });
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.close-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.close-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.close-error'
    });
  }
};

/**
 * Get all preorder events from the BE.
 * @param {object} qParams - Query parameters for filtering and pagination
 */
export const getAllPreorderEvents = (qParams: any) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'GET_PREORDER_EVENTS'
      });

      const apiParams = { ...qParams };
      if (qParams.archived !== undefined) {
        apiParams.isArchived = qParams.archived;
        delete apiParams.archived;
      }

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const res = await axios.get(`${apiURL}/admin/getAllPreorderEvents`, {
        params: apiParams,
        headers: headers
      });

      if (res.status === 200) {
        const responseData = res.data.data;
        const queryData = responseData.content;
        
        const preorderEvents: PreorderEventType[] = [];
        for (let i = 0; i < queryData.length; i++) {
          const preorderEvent = queryData[i];
          
          preorderEvents.push({
            id: preorderEvent.id,
            name: preorderEvent.name,
            releaseDate: preorderEvent.releaseDate,
            lastPreorderDate: preorderEvent.lastPreorderDate,
            archived: Boolean(preorderEvent.archived),
            closed: Boolean(preorderEvent.closed),
            postReleaseData: preorderEvent.postReleaseData,
            items: preorderEvent.items || [],
            itemsCount: preorderEvent.items ? preorderEvent.items.length : 0
          });
        }

        const data: PreorderEventList = {
          content: preorderEvents,
          first: responseData.first,
          last: responseData.last,
          number: responseData.number,
          size: responseData.size,
          totalPages: responseData.totalPages,
          totalElements: responseData.totalElements
        };

        dispatch({
          type: PREORDER_EVENTS_LIST,
          payload: data
        });
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.get-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.get-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.get-error'
    });
  }
};

/**
 * Get orders for a specific preorder event.
 * @param {number} preorderEventId
 * @param {object} qParams - pagination params (page, size)
 */
export const getPreorderEventOrders = (preorderEventId: number, qParams: any) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '' && preorderEventId) {
    try {
      dispatch({
        type: PREORDER_EVENT_ORDERS_LOADING,
        payload: 'GET_PREORDER_EVENT_ORDERS'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const res = await axios.get(`${apiURL}/admin/getAllPreorderOrders/${preorderEventId}`, {
        params: qParams,
        headers: headers
      });

      if (res.status === 200) {
        const responseData = res.data.data;
        const queryData = responseData.content;
        const orders = [] as any[];

        for (let i = 0; i < queryData.length; i++) {
          const order = queryData[i];
          orders.push({
            id: order.id || order.orderId,
            code: order.code || order.orderCode,
            status: order.status,
            customerName: order.customerName || order.name,
            name: order.name || order.customerName,
            email: order.email || order.customerEmail || '',
            creationDate: order.creationDate,
            totalPrice: order.totalPrice,
            processedBy: order.processedBy,
            processedByDate: order.processedByDate,
            readyPickupBy: order.readyPickupBy,
            readyPickupByDate: order.readyPickupByDate,
            completedBy: order.completedBy,
            completedDate: order.completedDate,
            notes: order.notes || [],
            partialPayment: order.partialPayment || [],
            paid: order.paid || false,
            items: order.items || [],
            sellerName: order.sellerName,
            sellerEmail: order.sellerEmail,
            vendorName: order.vendorName,
            vendorId: order.vendorId
          });
        }

        const data: PreorderEventOrdersList = {
          content: orders,
          first: responseData.first,
          last: responseData.last,
          number: responseData.number,
          size: responseData.size,
          totalPages: responseData.totalPages,
          totalElements: responseData.totalElements
        };

        dispatch({
          type: PREORDER_EVENT_ORDERS_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: PREORDER_EVENT_ORDERS_FAIL,
          payload: 'status.get-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENT_ORDERS_FAIL,
        payload: 'status.get-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENT_ORDERS_FAIL,
      payload: 'status.get-error'
    });
  }
};

/**
 * Update preorder order status with the correct payload for preorder orders.
 * @param {object} data - { orderId: number, status: string }
 */
export const updatePreorderOrderStatus = (data: { orderId: number; status: string }) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_ORDER_UPDATE_LOADING,
        payload: 'UPDATE_PREORDER_ORDER'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      // Preorder orders require specific payload format
      const bodyData = {
        isPaymentFinished: true,
        orderId: data.orderId,
        purchaseValidation: "VALIDADA",
        status: data.status
      };

      const res = await axios.put(`${apiURL}/seller/updateOrder`, bodyData, { headers });

      if (res.status === 200) {
        // Check if the status was actually updated
        const updatedStatus = res.data?.data?.status;
        if (updatedStatus === data.status) {
          dispatch({
            type: PREORDER_ORDER_UPDATE_SUCCESS,
            payload: 'status.success-update'
          });
        } else {
          dispatch({
            type: PREORDER_ORDER_UPDATE_FAIL,
            payload: 'status.no-validation-code'
          });
        }
      } else {
        dispatch({
          type: PREORDER_ORDER_UPDATE_FAIL,
          payload: 'status.error-update'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_ORDER_UPDATE_FAIL,
        payload: 'status.error-update'
      });
    }
  } else {
    dispatch({
      type: PREORDER_ORDER_UPDATE_FAIL,
      payload: 'status.error-update'
    });
  }
};

/**
 * Create a new preorder event on the BE.
 * @param {CreatePreorderEventRequest} preorderEventData
 */
export const createPreorderEvent = (preorderEventData: CreatePreorderEventRequest) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'CREATE_PREORDER_EVENT'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const bodyForm = {
        name: preorderEventData.name,
        releaseDate: preorderEventData.releaseDate,
        lastPreorderDate: preorderEventData.lastPreorderDate
      };

      const res = await axios.post(`${apiURL}/admin/registerPreorderEvent`, bodyForm, {
        headers: headers
      });

      if (res.status === 200 || res.status === 201) {
        dispatch({
          type: PREORDER_EVENTS_REGISTER,
          payload: 'status.success-create'
        });
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.create-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.create-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.create-error'
    });
  }
};

/**
 * Get preorder event details from the BE.
 * @param {number} preorderId
 */
export const getPreorderEventDetails = (preorderId: number) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'GET_PREORDER_EVENT_DETAILS'
      });

      const headers: object = {
        'Authorization': 'Bearer ' + userToken
      };

      const res = await axios.get(`${apiURL}/admin/getPreorderEventDetails/${preorderId}`, {
        headers: headers
      });

      if (res.status === 200) {
        let dataToSend = null;
        
        if (res.data && res.data.data) {
          dataToSend = res.data.data;
        } else if (res.data) {
          dataToSend = res.data;
        }
        
        if (dataToSend) {
          dispatch({
            type: PREORDER_EVENT_DETAILS_SUCCESS,
            payload: dataToSend
          });
        } else {
          dispatch({
            type: PREORDER_EVENTS_FAIL,
            payload: 'status.get-error'
          });
        }
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.get-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.get-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.get-error'
    });
  }
};

/**
 * Archive a preorder event on the BE.
 * @param {number} preorderId
 */
export const archivePreorderEvent = (preorderId: number) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'ARCHIVE_PREORDER_EVENT'
      });

      const headers: object = {
        'Authorization': 'Bearer ' + userToken
      };

      const res = await axios.put(`${apiURL}/admin/archivePreorderEvent/${preorderId}`, {}, {
        headers: headers
      });

      if (res.status === 200) {
        dispatch({
          type: PREORDER_EVENT_ARCHIVE_SUCCESS,
          payload: 'status.success-archive'
        });
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.archive-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.archive-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.archive-error'
    });
  }
};

/**
 * Update/unarchive a preorder event on the BE.
 * @param {number} preorderId
 * @param {PreorderEventDetails} preorderEventData
 */
export const updatePreorderEvent = (preorderId: number, preorderEventData: PreorderEventDetails) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'UPDATE_PREORDER_EVENT'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const bodyForm = {
        archived: true,
        id: preorderEventData.id,
        lastPreorderDate: preorderEventData.lastPreorderDate,
        name: preorderEventData.name,
        releaseDate: preorderEventData.releaseDate
      };

      const res = await axios.put(`${apiURL}/admin/updatePreorderEvent`, bodyForm, {
        headers: headers
      });

      if (res.status === 200) {
        dispatch({
          type: PREORDER_EVENT_ARCHIVE_SUCCESS,
          payload: 'status.success-unarchive'
        });
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.unarchive-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.unarchive-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.unarchive-error'
    });
  }
};

/**
 * Update preorder event details on the BE.
 * @param {number} preorderId
 * @param {object} updateData - The data to update (archived, name, lastPreorderDate, releaseDate)
 */
export const updatePreorderEventDetails = (preorderId: number, updateData: {
  archived: boolean;
  name: string;
  lastPreorderDate: string;
  releaseDate: string;
}) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;

  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'UPDATE_PREORDER_EVENT_DETAILS'
      });

      const headers: object = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      };

      const bodyForm = {
        archived: updateData.archived,
        id: preorderId,
        lastPreorderDate: updateData.lastPreorderDate,
        name: updateData.name,
        releaseDate: updateData.releaseDate
      };

      const res = await axios.put(`${apiURL}/admin/updatePreorderEvent`, bodyForm, {
        headers: headers
      });

      if (res.status === 200) {
        dispatch({
          type: PREORDER_EVENT_UPDATE_SUCCESS,
          payload: 'status.success-update-details'
        });
        
        dispatch(getPreorderEventDetails(preorderId) as any);
      } else {
        dispatch({
          type: PREORDER_EVENTS_FAIL,
          payload: 'status.update-details-error'
        });
      }
    } catch (e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.update-details-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.update-details-error'
    });
  }
};

/**
 * Add a new item to a preorder event.
 * @param {any} item - The item data with preorder-specific fields (must include preorderVendorId)
 */
export const addPreorderItem = (item: any) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'ADD_PREORDER_ITEM'
      });

      // Use the preorderVendorId passed from the preorder event details
      const preorderVendorId = item.preorderVendorId || getProjectConfig().VENDOR_ID;

      var bodyFormData = new FormData();
      item.name && bodyFormData.append('name', item.name);
      item.code && bodyFormData.append('code', item.code);
      item.commission && bodyFormData.append('commission', item.commission);
      item.costPrice && bodyFormData.append('costPrice', item.costPrice);
      item.minimumQuantity && bodyFormData.append('minimumQuantity', item.minimumQuantity);
      item.notes && bodyFormData.append('notes', item.notes);
      item.price && bodyFormData.append('price', item.price);
      item.weightPerUnit && bodyFormData.append('weightPerUnit', item.weightPerUnit);
      item.itemTypeId && bodyFormData.append('itemTypeId', item.itemTypeId);
      item.labelValuesIds && bodyFormData.append('labelValuesIds', item.labelValuesIds);
      
      (item.preorderQuantity || item.preorderQuantity === 0) && bodyFormData.append('quantity', item.preorderQuantity);
      
      bodyFormData.append('vendorId', String(preorderVendorId));
      
      item.preorderEventId && bodyFormData.append('preorderEventId', item.preorderEventId);

      if (item.preorderQuantity || item.preorderQuantity === 0) {
        bodyFormData.append(`quantities[0].quantity`, item.preorderQuantity);
        bodyFormData.append(`quantities[0].vendorId`, String(preorderVendorId));
      }

      if (item.files) {
        for (var i = 0; i < item.files.length; i++) {
          bodyFormData.append('files', item.files[i].file, String(i));
        } 
      }

      const configPOST = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'multipart/form-data',
        }
      };
    
      const addRes = await axios.post(`${getBasePath(['admin'])}/registerItem`, bodyFormData, configPOST);

      if (addRes.status === 200) {
        dispatch({
          type: PREORDER_ITEM_ADD_SUCCESS,
          payload: 'status.success-create'
        });
        
        if (item.preorderEventId) {
          dispatch(getPreorderEventDetails(item.preorderEventId) as any);
        }
      }
       
    } catch(e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.create-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.create-error'
    });
  }
};

/**
 * Update an existing preorder item.
 * @param {any} item - The updated item data
 */
export const updatePreorderItem = (item: any) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'UPDATE_PREORDER_ITEM'
      });

      const updateData = {
        id: item.id,
        name: item.name,
        code: item.sku,
        weightPerUnit: item.weightPerUnit,
        minimumQuantity: item.minimumQuantity,
        notes: item.notes,
        state: item.state,
        isPublished: item.isPublished
      };

      const configPUT = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'application/json',
        }
      };
    
      const updateRes = await axios.put(`${getBasePath(['admin'])}/updateItem`, updateData, configPUT);

      if (updateRes.status === 200) {
        dispatch({
          type: PREORDER_ITEM_UPDATE_SUCCESS,
          payload: 'status.success-update'
        });
        
        if (item.preorderEventId) {
          dispatch(getPreorderEventDetails(item.preorderEventId) as any);
        }
      }
       
    } catch(e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.update-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.update-error'
    });
  }
};

/**
 * Update the quantity of a preorder item.
 * @param {number} itemId - The item ID
 * @param {number} stock - The new stock quantity
 * @param {number} preorderEventId - The preorder event ID
 */
export const updatePreorderItemQuantity = (itemId: number, stock: number, preorderEventId?: number) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'UPDATE_PREORDER_ITEM_QUANTITY'
      });

      const updateData = {
        id: itemId,
        quantity: stock
      };

      const configPUT = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'application/json',
        }
      };
    
      const updateRes = await axios.put(`${getBasePath(['admin'])}/updateIndividualItem`, updateData, configPUT);

      if (updateRes.status === 200) {
        dispatch({
          type: PREORDER_ITEM_QUANTITY_UPDATE_SUCCESS,
          payload: 'status.success-update'
        });
        
        if (preorderEventId) {
          dispatch(getPreorderEventDetails(preorderEventId) as any);
        }
      }
       
    } catch(e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.update-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.update-error'
    });
  }
};

/**
 * Update item details for a preorder item.
 * @param {any} updateData - The update data object
 * @param {number} preorderEventId - The preorder event ID
 */
export const updatePreorderItemDetails = (updateData: any, preorderEventId?: number) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_EVENTS_LOADING,
        payload: 'UPDATE_PREORDER_ITEM_DETAILS'
      });

      // Create FormData object for multipart/form-data
      var bodyFormData = new FormData();
      
      // Add all fields to FormData
      if (updateData.id !== undefined) bodyFormData.append('id', updateData.id.toString());
      if (updateData.name) bodyFormData.append('name', updateData.name);
      if (updateData.code) bodyFormData.append('code', updateData.code);
      if (updateData.newCode) bodyFormData.append('newCode', updateData.newCode);
      if (updateData.costPrice !== undefined) bodyFormData.append('costPrice', updateData.costPrice.toString());
      if (updateData.minimumQuantity !== undefined) bodyFormData.append('minimumQuantity', updateData.minimumQuantity.toString());
      if (updateData.notes) bodyFormData.append('notes', updateData.notes);
      if (updateData.labelValuesIdsToAdd) bodyFormData.append('labelValuesIdsToAdd', updateData.labelValuesIdsToAdd);
      if (updateData.labelValuesIdsToRemove) bodyFormData.append('labelValuesIdsToRemove', updateData.labelValuesIdsToRemove);
      if (updateData.price !== undefined) bodyFormData.append('price', updateData.price.toString());
      if (updateData.weightPerUnit !== undefined) bodyFormData.append('weightPerUnit', updateData.weightPerUnit.toString());
      if (updateData.isFeature !== undefined) bodyFormData.append('isFeature', updateData.isFeature.toString());
      if (updateData.isPublished !== undefined) bodyFormData.append('isPublished', updateData.isPublished.toString());
      if (updateData.maxSellQuantity !== undefined) bodyFormData.append('maxSellQuantity', updateData.maxSellQuantity.toString());
      if (updateData.isConversionEnabled !== undefined) bodyFormData.append('isConversionEnabled', updateData.isConversionEnabled.toString());
      if (updateData.conversionQuantity !== undefined) bodyFormData.append('conversionQuantity', updateData.conversionQuantity.toString());
      if (updateData.itemCodeForConversion) bodyFormData.append('itemCodeForConversion', updateData.itemCodeForConversion);
      if (updateData.imagesIdToRemove) bodyFormData.append('imagesIdToRemove', updateData.imagesIdToRemove);

      if (updateData.files && Array.isArray(updateData.files)) {
        updateData.files.forEach((fileObj: any, index: number) => {
          if (fileObj?.file) {
            bodyFormData.append('files', fileObj.file, String(index));
          }
        });
      }

      const configPUT = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'multipart/form-data',
        }
      };
    
      const updateRes = await axios.put(`${getBasePath(['admin'])}/updateItem`, bodyFormData, configPUT);

      if (updateRes.status === 200) {
        dispatch({
          type: PREORDER_ITEM_QUANTITY_UPDATE_SUCCESS,
          payload: 'status.success-update'
        });
        
        if (preorderEventId) {
          dispatch(getPreorderEventDetails(preorderEventId) as any);
        }
      }
       
    } catch(e) {
      dispatch({
        type: PREORDER_EVENTS_FAIL,
        payload: 'status.update-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_EVENTS_FAIL,
      payload: 'status.update-error'
    });
  }
};

/**
 * Returns the base path based on the role.
 */
const getBasePath = (roles:Array<string>) => {
  const token: string | undefined = localStorage.token;
  
  if (!token) {
    return `${apiURL}/guest`;
  } else {
    const decodedToken:any = jwtDecode(String(token));
    if (decodedToken.auth.includes('ROLE_USER') && roles.includes('user')) {
      return `${apiURL}/user`;
    }
    if (decodedToken.auth.includes('ROLE_SELLER') && roles.includes('seller')) {
      return `${apiURL}/seller`;
    }
    if ((decodedToken.auth.includes('ROLE_ADMIN') || decodedToken.auth.includes('ROLE_SUPER_SELLER')) && !roles.includes('admin') && roles.includes('seller')) {
      return `${apiURL}/seller`;
    }
    if ((decodedToken.auth.includes('ROLE_ADMIN') || decodedToken.auth.includes('ROLE_SUPER_SELLER')) && roles.includes('admin')) {
      return `${apiURL}/admin`;
    }
    return `${apiURL}/user`;
  }
};

/**
 * Clear the suggested preorder close distribution from state
 */
export const clearSuggestedPreorderCloseDistribution = () => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  dispatch({
    type: PREORDER_EVENT_SUGGESTED_CLEAR
  });
};

/**
 * Bulk publish or unpublish all items in a preorder event.
 * @param {number} preorderEventId - The preorder event ID
 * @param {boolean} isPublished - True to publish, false to unpublish
 */
export const bulkPublishPreorderItems = (preorderEventId: number, isPublished: boolean) => async (dispatch: Dispatch<PreorderEventsDispatchTypes>) => {
  const userToken: string | undefined = localStorage.token;
  
  if (apiURL !== '' && userToken !== '') {
    try {
      dispatch({
        type: PREORDER_ITEMS_BULK_PUBLISH_LOADING,
        payload: 'BULK_PUBLISH_PREORDER_ITEMS'
      });

      const payload = {
        isPublished: isPublished,
        preorderEventId: preorderEventId
      };

      const config = {
        headers: {
          'Accept': '*/*',
          'Authorization': 'Bearer ' + userToken,
          'Content-Type': 'application/json',
        }
      };
    
      const updateRes = await axios.put(`${apiURL}/admin/managePreorderEventItems`, payload, config);

      if (updateRes.status === 200) {
        dispatch({
          type: PREORDER_ITEMS_BULK_PUBLISH_SUCCESS,
          payload: 'status.success-update'
        });
        
        // Refresh the preorder event details
        dispatch(getPreorderEventDetails(preorderEventId) as any);
      }
       
    } catch(e) {
      dispatch({
        type: PREORDER_ITEMS_BULK_PUBLISH_FAIL,
        payload: 'status.update-error'
      });
    }
  } else {
    dispatch({
      type: PREORDER_ITEMS_BULK_PUBLISH_FAIL,
      payload: 'status.update-error'
    });
  }
};